import style from "../calculator.module.css";
import { quantityBoomakerChanger } from "../../../utils/calculator/Edition";
function EditableProtectionGame(props) {
  const {
    statusMode,
    itemCount,
    setItemCount,
    dataOperation,
    typeSurebet,
    calculatreBonusBookmakerAndSurebet,
    calculateSurebet,
    selectedBookmaker,
    setSelectedBookmaker,
    stakeChangeNormalSurebet,
    managerCalcRiskFreeBettingFormula,
    manageSurebetLockedValueFormula
  } = props;
  const handleChangeInputQuantityBet = (e) => {
    const value = parseInt(e.target.value, 10);
    if (isNaN(value) || value < 0) return;
    setItemCount(value);
    const quantityBoomakersChanged = quantityBoomakerChanger(
      value,
      dataOperation
    );
    const selectedBookmakerInflated = selectedBookmaker + 1;
    let selectedBookmakerCorrected = selectedBookmaker;
    if (quantityBoomakersChanged.length < selectedBookmakerInflated) {
      selectedBookmakerCorrected = -1;
      setSelectedBookmaker(selectedBookmakerCorrected);
    }
    if (typeSurebet === "bonus_bookmaker") {
      calculatreBonusBookmakerAndSurebet({
        dataOperationFreeBookmaker: quantityBoomakersChanged
      });
    } else if (typeSurebet === "risk_free_betting") {
      managerCalcRiskFreeBettingFormula({ paramBookmakers: quantityBoomakersChanged });
    } else if (typeSurebet === "locked_value") {
      manageSurebetLockedValueFormula({ paramBookmakers: quantityBoomakersChanged });
    } else {
      if (selectedBookmakerCorrected > -1) {
        stakeChangeNormalSurebet(
          selectedBookmakerCorrected,
          quantityBoomakersChanged[selectedBookmakerCorrected]["stake"],
          false,
          false,
          0,
          quantityBoomakersChanged
        );
      } else {
        calculateSurebet({ paramBookmakers: quantityBoomakersChanged });
      }
    }
  };
  return (
    <>
      Número de Proteções:{" "}
      <input
        className={`align-self-center form-control ${statusMode
            ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}`
            : ""
          }  `}
        type="number"
        defaultValue={itemCount}
        onChange={handleChangeInputQuantityBet}
        min={0}
      />
    </>
  );
}
export {
  EditableProtectionGame
};